module.exports = {"id":"182207","name":"David Stockdale","rating":"72","photo":"./data/images/photos/3/182207.png","club":{"name":"Birmingham City","logo":"./data/images/clubs/BirminghamCity.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavidStockdale0.json
// module id = 1008
// module chunks = 0